// La red nunca participa en la confirmación de un guardado local.
const localTasks = new Map();
const syncTasks = new Map();

export const VISITA_SYNC_REQUESTED = 'visita:sync-requested';
export const VISITA_DRAFT_ACKNOWLEDGED = 'visita:draft-acknowledged';
export const VISITA_STRUCTURE_ACKNOWLEDGED = 'visita:structure-acknowledged';

export function cloneVisitaSnapshot(source = {}) {
    source = source || {};
    return JSON.parse(JSON.stringify({
        ...(source.offline_merge_pilot === true ? {offline_merge_pilot:true} : {}),
        ...Object.fromEntries(['instance_owners', 'excluded_from_report_fields', 'excluded_subgroup_instances',
            'excluded_manual', 'excluded_auto', 'hidden_response_fields'].filter((key) => source[key] !== undefined)
            .map((key) => [key, source[key]])),
        responses: source.responses || {},
        dynamic_group_items: source.dynamic_group_items || [],
        custom_subgroup_names: source.custom_subgroup_names || {},
        instance_states: source.instance_states || {},
        observacion: source.observacion ?? null,
        estado_sistema: source.estado_sistema ?? null,
    }));
}

export function createLocalFirstPayload(snapshot, baseSnapshot, existingPayload) {
    // Un pendiente antiguo sin base conserva su formato hasta ser confirmado.
    if (existingPayload && !existingPayload._local_first) return cloneVisitaSnapshot(snapshot);
    return {
        ...cloneVisitaSnapshot(snapshot),
        _local_first: {
            base: cloneVisitaSnapshot(existingPayload?._local_first?.base || baseSnapshot),
        },
    };
}

export function getVisitaSyncPayload(payload) {
    if (!payload?._local_first) return payload;
    const base = payload._local_first.base;
    const patch = {};
    for (const name of ['responses', 'custom_subgroup_names', 'instance_states']) {
        const delta = {};
        const current = payload[name] || {};
        const previous = base[name] || {};
        for (const key of new Set([...Object.keys(previous), ...Object.keys(current)])) {
            if (JSON.stringify(current[key]) !== JSON.stringify(previous[key])) {
                delta[key] = current[key] === undefined ? null : current[key];
            }
        }
        if (Object.keys(delta).length) patch[name] = delta;
    }
    for (const name of ['observacion', 'estado_sistema']) {
        if (payload[name] !== base[name]) patch[name] = payload[name] ?? null;
    }
    // El contador remoto se modifica por add_group, nunca por un snapshot local.
    return patch;
}

function serialize(tasks, key, task) {
    const previous = tasks.get(key) || Promise.resolve();
    const next = previous.catch(() => {}).then(task);
    tasks.set(key, next);
    return next.finally(() => {
        if (tasks.get(key) === next) tasks.delete(key);
    });
}

export function withVisitaLocalLock(userId, visitaId, task) {
    const key = `${userId}:${visitaId}`;
    return serialize(localTasks, key, () => {
        if (typeof navigator !== 'undefined' && navigator.locks?.request) {
            return navigator.locks.request(`visita-local:${key}`, task);
        }
        return task();
    });
}

export function withVisitaSyncLock(userId, visitaId, task) {
    return serialize(syncTasks, `${userId}:${visitaId}`, () => {
        if (globalThis.navigator?.locks?.request) return navigator.locks.request(`visita-sync:${userId}:${visitaId}`, task);
        return task();
    });
}

export function requestVisitaSync(options = {}) {
    if (typeof window !== 'undefined') window.dispatchEvent(new CustomEvent(VISITA_SYNC_REQUESTED, { detail: {newCycle:true,...options} }));
}

export function hasPendingVisitaStructure(operations, visitaId) {
    return operations.some((op) => Number(op.visitaId) === Number(visitaId)
        && ['iniciar_visita', 'add_group', 'remove_group', 'split_work'].includes(op.type) && op.status !== 'applied');
}
